import { t } from "i18next";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { useAppStore } from "../../stores/RootStore";
import { FShift } from "../../types/types";
import { Button } from "../../ui/Button";
import { Label } from "../../ui/Label/Label";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";
import { Switch } from "../../ui/Switch/Switch";

type Props = {
  chosenShifts: Array<FShift>;
  setChosenShifts: Function;
};

function MultiShiftPicker({ chosenShifts, setChosenShifts }: Props) {
  const shifts = useAppStore((state) => state.shifts);

  const onChange = (e: boolean, shift: FShift) => {
    e ? setChosenShifts([...chosenShifts, shift]) : setChosenShifts(chosenShifts.filter((sh) => sh.id != shift.id));
  };

  const checkShiftTime = (shift: FShift) => {
    // Вычитаем лишние дни
    const shiftStart = shift.start_at.toSeconds() - shift.start_at.startOf("day").toSeconds();
    const shiftEnd = shift.end_at.toSeconds() - shift.end_at.startOf("day").toSeconds();

    for (let el of chosenShifts) {
      // Вычитаем лишние дни
      const elStart = el.start_at.toSeconds() - el.start_at.startOf("day").toSeconds();
      const elEnd = el.end_at.toSeconds() - el.end_at.startOf("day").toSeconds();

      // Логика для полного дня
      if (el.id == "full" && shift.id != "full") return true;
      if (chosenShifts.filter((sh) => sh.id != "full").length > 0 && shift.id == "full") return true;

      if (elStart < elEnd) {
        if (shiftStart < shiftEnd) {
          if (shiftStart < elEnd && shiftEnd > elStart && shift.id != el.id) return true;
        } else {
          // shiftStart > shiftEnd (проверяемая смена проходит через 0)
          if (elEnd > shiftStart || elStart < shiftEnd) return true;
        }
      } else {
        // elStart > elEnd (выбранная смена проходит через 0)
        if (shiftStart < shiftEnd) {
          if (shiftStart < elEnd || shiftEnd > elStart) return true;
        } else {
          // shiftStart > shiftEnd (проверяемая смена проходит через 0)
          if (shift.id != el.id) return true;
        }
      }
    }
    return false;
  };

  return (
    <>
      <Popover>
        <PopoverTrigger asChild>
          <Button size={"sm"} variant={"outline"} className="justify-start items-center px-1 gap-1">
            {(chosenShifts.length > 0)
              ? chosenShifts.map((s) => (
                  <div key={s.id} className="px-2 flex py-0.5 bg-primary rounded-sm text-background text-sm">
                    {s.start_at.toISOTime({suppressSeconds: true, includeOffset: false})} - {s.end_at.toISOTime({suppressSeconds: true, includeOffset: false})}
                  </div>
                ))
              : 
              <div className="flex h-full px-1 items-center">
                {t("shifts")}
              </div>
              }
          </Button>
        </PopoverTrigger>
        <PopoverContent side="bottom" align="start" className="py-2 px-0">
          <div className="text-lg font-medium px-4 py-2 space-y-2">{t("shifts")}</div>
          {shifts.map((shift) => {
            return (
              <div key={shift.id} className="flex py-1 mx-2 hover:bg-secondary items-center rounded">
                <Label htmlFor={shift.id} className="flex w-full flex-col px-2 pt-1">
                  <div className="text-sm font-medium">{shift.name}</div>
                  <div className="text-sm font-normal leading-6">
                    {shift.start_at.toLocaleString(DateTime.TIME_24_SIMPLE)}-
                    {shift.end_at.toLocaleString(DateTime.TIME_24_SIMPLE)}
                  </div>
                </Label>
                <div className="px-2">
                  <Switch
                    id={shift.id}
                    disabled={checkShiftTime(shift)}
                    checked={chosenShifts.map((sh) => sh.id).includes(shift.id)}
                    onCheckedChange={(e) => onChange(e, shift)}
                  />
                </div>
              </div>
            );
          })}
        </PopoverContent>
      </Popover>
    </>
  );
}

export default MultiShiftPicker;
